import { Link } from 'react-router-dom';
import { FeatherLogo } from '../components/FeatherLogo';
import { usePageMeta } from '../lib/meta';

export function NotFoundPage() {
  usePageMeta({
    title: 'Page not found',
    description: 'The page you requested is not part of the collection.',
    path: '/',
  });

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-24 text-center sm:px-6">
      <FeatherLogo className="h-20 w-20 text-tail-600" />
      <h1 className="mt-8 font-display text-4xl text-plume-950">This page has flown.</h1>
      <p className="mt-4 text-lg leading-relaxed text-plume-800">
        Whatever you were seeking is not in the collection, was never in the collection, or has been
        removed by the editorial board and is no longer spoken of.
      </p>
      <Link to="/" className="btn-gloss mt-8">
        Return home
      </Link>
    </div>
  );
}
